<template>
<div class="AdminPanelBaskets page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
  <BackBtn />
  <BreadCrumbs :items="breadcrumbs" />
  <div class=" d-flex align-center pb-4 mb-4">
    <h1 class="font-lg">Просмотр покупок и корзин пользователя</h1>
  </div>
  <div class="row">
    <div class="col-12 tab">
      <div class="tab__header">
        <v-tabs
          v-model="currentTab"
          active-class="active_tab"
          slider-size="2"
          @change="onTabChange"
        >
          <v-tab
            v-for="(item,idx) in tabs"
            :key="idx"
            class="item"
          >
            {{item.title}}
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="currentTab" class="tab__content">
        <v-tab-item
          v-for="(item,idx) in tabs"
          :key="idx"
        >
          <component :is="item.component" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
  <div>
    <!--  Modals Window  -->
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TableBaskets from '@/components/admin-panel/TableBaskets.vue';
import TableOrders from '@/components/admin-panel/TableOrders.vue';

/**
 * Компонент: AdminPanelBaskets
 * Описание:
 */
export default {
  name: 'AdminPanelBaskets',

  components: { TableBaskets, TableOrders },

  props: {},

  data() {
    return {
      currentTab: 0,

      tabs: [
        {
          name: 'orders',
          title: 'Оформленные услуги',
          component: 'TableOrders',
        },
        {
          name: 'baskets',
          title: 'Услуги в корзине',
          component: 'TableBaskets',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    breadcrumbs() {
      return [
        { title: 'Админка', url: '/admin-panel' },
        { title: 'Просмотр покупок и корзин пользователя', url: '' },
      ];
    },
    activeTabFromQuery() {
      return this.$route.query.tab;
    },
  },

  watch: {},

  created() {
  },

  async mounted() {
    await this.fetchAllBaskets();
    await this.fetchAllOrders();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions(
      {
        fetchAllBaskets: 'basket/basket/fetchAllBaskets',
        fetchAllOrders: 'basket/basket/fetchAllOrders',
      }
    ),
    onTabChange(tabIndex) {
      if (this.activeTabFromQuery) {
        const tab = this.tabs[tabIndex];
        if (tab) {
          this.$router.push({
            query: {
              ...this.$route.query,
              tab: tab.name
            }
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.AdminPanelBaskets {
  .tab {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & .tab__header {
      padding: 16px 24px;
      & ::v-deep.v-tabs-bar{
        background: transparent;
      }
      & .active_tab.item {
        color: #483CB9;
        font-weight: 600;

        &:before {
          opacity: 0;
          display: none;
        }

        :after {
          display: none;
        }
      }

      & .item {
        color: #818181;
        text-transform: none;
        font-size: 14px;

        &:before {
          opacity: 0;
          display: none;
        }
      }
    }
  }
}
</style>
